import { XIcon } from "lucide-react";
import { ComponentProps } from "@tw-classed/react";

import { IconButton } from "../Button";

export const CloseButtonIcon = XIcon;

export function CloseButton(props: Partial<ComponentProps<typeof IconButton>>) {
  let icon = <XIcon className="size-6" />;
  if (props.size === "sm") {
    icon = <XIcon className="size-5" />;
  }
  if (props.size === "xs") {
    icon = <XIcon className="size-4" />;
  }
  return (
    <IconButton variant="ghost" icon={icon} {...props}>
      <span className="sr-only">Close panel</span>
    </IconButton>
  );
}
